/* WDJ Sky — theme behaviour. No dependencies. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function formatMoney(n, decimals) {
    return '$' + Number(n).toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  /* Mobile menu */
  function initMenu(root) {
    root.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        nav.setAttribute('data-open', String(!open));
      });
    });
  }

  /* Rate estimators: data-estimator on a wrapper, a .range input, and
     outputs with data-multiplier. Values are indicative only. */
  function initEstimators(root) {
    root.querySelectorAll('[data-estimator]').forEach(function (el) {
      var input = el.querySelector('input[type="range"]');
      var display = el.querySelector('[data-estimator-input]');
      var outputs = el.querySelectorAll('[data-multiplier]');
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      if (!input) return;
      function update() {
        var v = Number(input.value);
        if (display) display.textContent = formatMoney(v, 0);
        outputs.forEach(function (o) {
          o.textContent = formatMoney(v * Number(o.getAttribute('data-multiplier')), decimals);
        });
        input.setAttribute('aria-valuetext', formatMoney(v, 0));
      }
      input.addEventListener('input', update);
      update();
    });
  }

  /* "This can help when…" checklist. Selected items are copied into the
     hidden message field of every consultation form on the page. */
  function initChecklist(root) {
    root.querySelectorAll('[data-checklist]').forEach(function (list) {
      var buttons = list.querySelectorAll('[data-check]');
      var count = list.querySelector('[data-check-count]');
      function sync() {
        var picked = [];
        buttons.forEach(function (b) {
          if (b.getAttribute('aria-pressed') === 'true') picked.push(b.getAttribute('data-check'));
        });
        if (count) count.textContent = picked.length + ' of ' + buttons.length + ' selected';
        document.querySelectorAll('[data-consult-notes]').forEach(function (field) {
          var base = field.getAttribute('data-base') || '';
          field.value = picked.length ? base + '\n\nThis can help when:\n- ' + picked.join('\n- ') : base;
        });
      }
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          b.setAttribute('aria-pressed', String(b.getAttribute('aria-pressed') !== 'true'));
          sync();
        });
      });
      sync();
    });
  }

  /* Page hero "This can help when" card. Selected points are passed to the
     contact page as ?need=… parameters on the card's button link. */
  function initHelpCards(root) {
    root.querySelectorAll('[data-help-card]').forEach(function (card) {
      var items = card.querySelectorAll('[data-help-item]');
      var count = card.querySelector('[data-help-count]');
      var link = card.querySelector('[data-help-link]');
      var empty = count ? count.textContent : '';
      var base = link ? link.getAttribute('href') : '';
      function sync() {
        var picked = [];
        items.forEach(function (b) {
          if (b.getAttribute('aria-pressed') === 'true') picked.push(b.getAttribute('data-help-item'));
        });
        if (count) {
          count.textContent = picked.length ? picked.length + ' ticked · added to your inquiry' : empty;
          count.toggleAttribute('data-selected', picked.length > 0);
        }
        if (link) {
          var url = new URL(base, window.location.origin);
          var services = [];
          items.forEach(function (b) {
            var key = b.getAttribute('data-help-service');
            if (key && b.getAttribute('aria-pressed') === 'true' && services.indexOf(key) === -1) services.push(key);
          });
          if (!url.searchParams.has('service') && services.length === 1) url.searchParams.set('service', services[0]);
          picked.forEach(function (p) { url.searchParams.append('need', p); });
          link.setAttribute('href', url.pathname + url.search);
        }
      }
      items.forEach(function (b) {
        b.addEventListener('click', function () {
          b.setAttribute('aria-pressed', String(b.getAttribute('aria-pressed') !== 'true'));
          sync();
        });
      });
      sync();
    });
  }

  /* Page hero "This can help when" card, rotating style. Each dot's progress
     bar is a CSS animation; the next point is shown when it ends, so pausing
     the animation (hover, focus or the pause button) pauses the rotation. */
  function initHelpCarousels(root) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-help-carousel]').forEach(function (card) {
      var rotator = card.querySelector('.help-rotator');
      var slides = card.querySelectorAll('[data-help-slide]');
      var dots = card.querySelectorAll('[data-help-dot]');
      var index = card.querySelector('[data-help-index]');
      var pause = card.querySelector('[data-help-pause]');
      var current = 0, userPaused = false, hovered = false, focused = false;
      if (slides.length < 2) { card.querySelector('.help-rotator__controls').hidden = true; return; }
      if (reduce && pause) pause.hidden = true;

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === current);
          s.setAttribute('aria-hidden', String(n !== current));
        });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-done', n < current);
          if (n === current) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        if (index) index.textContent = String(current + 1).padStart(2, '0');
      }
      function syncPaused() {
        var paused = userPaused || hovered || focused;
        rotator.toggleAttribute('data-paused', paused);
      }

      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { show(n); });
        d.querySelector('span').addEventListener('animationend', function () {
          if (n === current) show(current + 1);
        });
      });
      if (pause) {
        pause.addEventListener('click', function () {
          userPaused = !userPaused;
          pause.setAttribute('aria-pressed', String(userPaused));
          pause.setAttribute('aria-label', userPaused ? 'Play' : 'Pause');
          syncPaused();
        });
      }
      card.addEventListener('mouseenter', function () { hovered = true; syncPaused(); });
      card.addEventListener('mouseleave', function () { hovered = false; syncPaused(); });
      card.addEventListener('focusin', function () { focused = true; syncPaused(); });
      card.addEventListener('focusout', function (e) {
        if (!card.contains(e.relatedTarget)) { focused = false; syncPaused(); }
      });
      show(0);
    });
  }

  /* Contact form: pre-select the service from ?service=<key> and add any
     ?need=… points from a page hero card to the message. */
  function initServiceSelect(root) {
    var params = new URLSearchParams(window.location.search);
    var key = params.get('service');
    root.querySelectorAll('[data-service-select]').forEach(function (select) {
      if (key) {
        Array.prototype.forEach.call(select.options, function (opt) {
          if (opt.getAttribute('data-handle') === key) select.value = opt.value;
        });
      }
      /* Staffing fields only appear once a staffing service is chosen. */
      var extra = select.form && select.form.querySelector('[data-staffing-fields]');
      if (!extra) return;
      function sync() {
        var opt = select.options[select.selectedIndex];
        extra.hidden = !opt || opt.getAttribute('data-handle') !== 'staffing';
      }
      select.addEventListener('change', sync);
      sync();
    });
    var needs = params.getAll('need').filter(Boolean).slice(0, 12);
    if (!needs.length) return;
    root.querySelectorAll('[data-prefill-needs]').forEach(function (field) {
      if (field.value.trim()) return;
      field.value = 'Situations that apply:\n- ' + needs.join('\n- ') + '\n\nMore details:\n';
      field.rows = Math.max(field.rows, needs.length + 5);
      var notice = field.parentNode.querySelector('[data-prefill-notice]');
      if (notice) notice.hidden = false;
    });
  }

  function init(root) {
    initServiceSelect(root);
    initMenu(root);
    initEstimators(root);
    initChecklist(root);
    initHelpCards(root);
    initHelpCarousels(root);
  }

  ready(function () { init(document); });

  /* Re-initialise sections when edited in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
